import React from 'react';
import './badge.scss';

// Outlined pill showing a short status (e.g. "Verified", "Missing"). The text
// and outline share one colour. `color` is 'green' or 'red' (shades chosen for
// at least 4.5:1 contrast on white and on the grid's alternate-row colour), or
// any other CSS colour.
const NAMED_COLORS = {
  green: '#2e7d32',
  red: '#c62828',
};

export default function Badge({ text, color = 'green', className = '' }) {
  return (
    <span
      className={`badge ${className}`.trim()}
      style={{ color: NAMED_COLORS[color] ?? color }}
    >
      {text}
    </span>
  );
}
